import { message } from 'antd';

export const handleApiResponse = (response, data, successMessage = null) => {
  if (response.ok) {
    message.success(data.message || successMessage || 'Operação realizada com sucesso!');
    return true;
  } else {
    // Tratamento de erros de validação
    if (data.errors) {
      // Pega o primeiro erro encontrado
      const firstError = Object.values(data.errors)[0];
      if (Array.isArray(firstError)) {
        message.error(firstError[0] || 'Erro ao processar a requisição');
      } else {
        message.error(firstError || 'Erro ao processar a requisição');
      }
    } else {
      message.error(data.message || 'Erro ao processar a requisição');
    }
    return false;
  }
};

export const handleApiError = (error) => {
  console.error('Erro completo:', error);
  message.error('Erro ao conectar com a API');
  return false;
}; 